import { SvgConfig } from './MandatsamlingSvg'

export const configurations = [
  {
    min: 0,
    max: 15,
    config: {
      rows: 1,
      radius: 10,
      spacing: 3,
      marginHorizontal: 2,
      marginVertical: 2
    }
  },
  {
    min: 16,
    max: 25,
    config: {
      rows: 2,
      radius: 10,
      spacing: 3,
      marginHorizontal: 2,
      marginVertical: 2
    }
  },
  {
    min: 26,
    max: 45,
    config: {
      rows: 3,
      radius: 7.5,
      spacing: 2,
      marginHorizontal: 2,
      marginVertical: 2
    }
  },
  {
    min: 46,
    max: 52,
    config: {
      rows: 3,
      radius: 7.5,
      spacing: 2,
      marginHorizontal: 2,
      marginVertical: 2
    }
  },
  {
    min: 53,
    max: 65,
    config: {
      rows: 3,
      radius: 6,
      spacing: 2,
      marginHorizontal: 2,
      marginVertical: 2
    }
  },
  {
    min: 59,
    max: 86,
    config: {
      rows: 3,
      radius: 5,
      spacing: 2,
      marginHorizontal: 2,
      marginVertical: 2
    }
  },
  {
    min: 87,
    max: 100,
    config: {
      rows: 4,
      radius: 6,
      spacing: 2,
      marginHorizontal: 2,
      marginVertical: 2
    }
  }
]

export function getKommunestyreConfig(totaltAntall: number) {
  const config = configurations.find(({ min, max }) => min <= totaltAntall && max >= totaltAntall)
  if (!config) {
    throw new Error(
      `Kunne ikke finne konfigurasjon for MandatsamlingSvg med størrelse ${totaltAntall}`
    )
  }
  return config.config
}

const MAX_AVAILABLE_WIDTH = 150

export function getMandatfordelingConfig(totaltAntall: number, storstAntall: number): SvgConfig {
  const config = getKommunestyreConfig(totaltAntall)
  const mandatWidth = 2 * config.radius + config.spacing
  const rows = Math.ceil((storstAntall * mandatWidth) / MAX_AVAILABLE_WIDTH)
  return {
    ...config,
    rows
  }
}
